import React, { Fragment, useEffect, useState } from "react";
import styles from "./scss/task-view-details.module.scss";
import taskimg1 from "../../../styles/images/task1.svg";
import iconpdf from "../../../styles/images/grid_pdf.svg";
import iconppt from "../../../styles/images/grid_ppt.svg";
import iconword from "../../../styles/images/grid_word.svg";
import iconxls from "../../../styles/images/grid_xls.svg";
import iconzip from "../../../styles/images/grid_zip.svg";


import taskimg2 from "../../../styles/images/task2.svg";
import { Progress, Menu, Dropdown, Select, Tooltip, DatePicker, Space, Modal, Slider } from "antd";
import { StatusTag } from "../../../shared/widgets/statusTag";
import { URButton } from "../../../shared/widgets/button";
import { useSelector } from "react-redux";
import {
  LoginState, initialStateModel,
  contacts, chatwindowDetails, chats
} from "../../../models/model";
import {
  excelFormats, getcontactDetail, getCookie,
  imageFormat, pptFormats, SearchFilter, videoFormat, wordFormats, zipFormats
} from "../../../base/utils";
import axios from "axios";
import { config } from "../../../base/constant";
import { contactService } from "../../../base/contactService";
import { RRule } from 'rrule';
import moment from "moment";
import TextArea from "antd/lib/input/TextArea";
import ClickDropdown from "../../../shared/widgets/clickDropdown";
import { toastInformation, userStatusColor } from "../../../base/callService/common";
import { URStatusDot } from "../../../shared/widgets/avatarGroup/statusDot";
import _ from "lodash";
import { chatSideWindow, TaskRRuleGeneration } from "../../../base/eventService/eventApiService";
import { URCheckBoxCall } from "../../../shared/widgets/checkbox/callCheckBox";
import { URAvatarGroup } from "../../../shared/widgets/avatarGroup";
import ImageZoom from "../chatsection/imagezoom";
import { ChatService } from "../../../base/chatService";

type TaskViewPage = {
  assigneeDetials: any,
  reportToDetials: any,
  startDate: Date,
  endDate: Date,
  name: any,
  description: any,
  assigneeError: boolean,
  reportError: boolean,
  maxReportError: boolean,
  attachmentArray: any,
  startTime: any,
  endTime: any,
  startTimeError: boolean,
  rruleValue: any,
  rruleText: any,
  recurrence: any,
  taskStatus: string,
  taskPriority: string,
  taskPercentage: number,
  isRecur: boolean,
  endError: boolean,
  endTimeError: boolean,
  uid: any
}
export default function TaskViewDetails(props: any) {
  let isContact = window.location.pathname === "/contacts" ? true : false;
  const [isAssignee, setisAssignee] = useState(false);
  const [isEndEdit, setEndEdit] = useState(false);
  const [isStartEdit, setStartEdit] = useState(false);
  const [assigneAdd, setAssigneeAdd] = useState(false);
  const [reportAdd, setReportAdd] = useState(false);
  const [videoduration, setVideoduration] = useState("00:00:00");
  const [deletetask, setdeleteTask] = useState(false);

  const [currentduration, setCurrentduration] = useState("00:00");
  const [deleteModal, setDeleteModal] = useState({ isModalVisible: false, file: '' });
  const [seektime, setseektime] = useState(0);
  const [previewFile, setpreviewFile] = useState({ isModalVisible: false, fileToOpen: '', filename: "", filext: "" });
  const [previewVideo, setpreviewVideo] = useState({ isvideoModal: false, fileToOpen: '', filename: "", filext: "" })
  const [previewImage, setpreviewImage] = useState({ isImageModal: false, fileToOpen: '', filename: "", filext: "" })
  const loginDetails: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  // const chatReducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  let { workContacts }: contacts = useSelector((state: initialStateModel) => state.contactReducer);
  const chatWindow: chatwindowDetails = useSelector((state: initialStateModel) => state.chatWindowReducer);
  const chat_reducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  //let {chatWindowDetails ,isMySpace}=chatWindow;
  let memberList = chatWindow?.chatWindowDetails?.team_members?.split(",");
  memberList = Array.isArray(memberList) && memberList.length > 0 ?
    memberList.map((data: any, index: any) => data.trim()) : [];
  const [createTask, setcreateTask] = useState<TaskViewPage>({
    attachmentArray: [],
    taskPercentage: 0, isRecur: false,
    startDate: new Date(), startTime: "", endDate: new Date(), endTime: "", name: "", taskStatus: "",
    description: "", assigneeDetials: [], reportToDetials: [],
    assigneeError: false, reportError: false, maxReportError: false, rruleValue: "", startTimeError: false,
    rruleText: "", recurrence: "", taskPriority: "", uid: "", endError: false, endTimeError: false
  });

  const [selectAssignee, setSelectAssignee] = useState({
    contactList: workContacts, searchContactList: workContacts, contactDetail: [],
    selectedmember: []
  });
  const [selectReportTo, setSelectReportTo] = useState({
    contactList: workContacts, searchContactList: workContacts, contactDetail: [],
    selectedmember: []
  });

  let { userdetails } = loginDetails;
  let taskData: any = props.taskData;
  const [isPlay, setPlay] = useState(false);

  const handlePausePlay = () => {
    let video: any = document.getElementById("videoPlayer");


    if (isPlay) {
      video.pause();
      setPlay(false)
    }
    else {
      video.addEventListener("timeupdate", seektimeupdate, false);
      video.play();
      setPlay(true)
    }

  }
  const seektimeupdate = () => {
    //let seekslider:any = document.getElementById("seekslider");
    let vid: any = document.getElementById("videoPlayer");
    var nt = vid.currentTime * (100 / vid.duration);
    //seekslider.value = nt;

    setseektime(nt)
    var curmins: any = Math.floor(vid.currentTime / 60);
    var cursecs: any = Math.floor(vid.currentTime - curmins * 60);
    var durmins: any = Math.floor(vid.duration / 60);
    var dursecs: any = Math.floor(vid.duration - durmins * 60);
    if (cursecs < 10) { cursecs = "0" + cursecs; }
    if (dursecs < 10) { dursecs = "0" + dursecs; }
    if (curmins < 10) { curmins = "0" + curmins; }
    if (durmins < 10) { durmins = "0" + durmins; }

    let currDuration = curmins + ":" + cursecs


    setCurrentduration(currDuration)
    if (currDuration === videoduration) {
      setPlay(false);
      setCurrentduration('00:00')
      setseektime(0);
    }

  };
  const duration = (time: any) => {
    let timeDuration: any;
    let d = Number(time);
    let h = Math.floor(d / 3600);
    let m = Math.floor(d % 3600 / 60);
    let s = Math.floor(d % 3600 % 60);

    let hDisplay = h > 0 ? `0${h}` : h > 10 ? h : "00";
    let mDisplay = m < 9 ? `0${m}` : m > 10 ? m : "00";
    let sDisplay = s < 9 ? `0${s}` : s > 10 ? s : "00";
    timeDuration = hDisplay > 0 ? `${hDisplay}:${mDisplay}:${sDisplay}` : `${mDisplay}:${sDisplay}`;
    return timeDuration;
  }

  const downloadAlfilesfromAttach = (previewFile: any) => {

    let fileToOpen = previewFile.fileToOpen;
    let filename = previewFile.filename;
    var xhr = new XMLHttpRequest();
    xhr.open("GET", fileToOpen, true);
    xhr.responseType = "blob";
    xhr.onload = function () {
      var urlCreator = window.URL || window.webkitURL;
      var imageUrl = urlCreator.createObjectURL(this.response);
      var tag = document.createElement("a");
      tag.href = imageUrl;
      tag.download = filename;
      document.body.appendChild(tag);
      tag.click();
      document.body.removeChild(tag);
    };
    xhr.send();
  }
  useEffect(() => {

    if (props.taskData?.attendee) {
      let Assignee: any = [];
      props.taskData?.attendee?.map((list: any) => (
        Assignee.push(list)
      ));
      let checkAssignee: boolean = Assignee.indexOf(userdetails.sip_login_id) !== -1 ? true : false;
      setisAssignee(checkAssignee);
    }
    let assigneeDetial: any = [];
    let assigneeMember: any = [];
    taskData?.attendee?.map((list: any) => {
      assigneeDetial.push(getcontactDetail(list));
      assigneeMember.push(parseInt(list));
    });

    let reportToDetial: any = [];
    let reportMember: any = [];
    taskData?.reportTo?.map((list: any) => {
      reportToDetial.push(getcontactDetail(list));
      reportMember.push(parseInt(list));
    });

    let start = props.taskData?.dtstart === "" ? new Date() : new Date(parseFloat(props.taskData?.dtstart) * 1000);
    var end_date = new Date(parseFloat(props.taskData.dtend) * 1000);

    let editRRule: any = (props.taskData?.rrule !== undefined && props.taskData?.rrule !== "") ? new RRule(RRule.parseString(props.taskData?.rrule)) : "";
    setSelectAssignee({
      ...selectAssignee,
      contactDetail: assigneeDetial,
      selectedmember: assigneeMember
    });
    setSelectReportTo({
      ...selectReportTo,
      contactDetail: reportToDetial,
      selectedmember: reportMember
    });

    setcreateTask({
      ...createTask, recurrence: props.taskData?.recurOptions, rruleText: (props.taskData?.rrule !== undefined && props.taskData?.rrule !== "") ? editRRule.toText() : "",
      isRecur: props.taskData?.recurOptions && props.taskData?.recurOptions !== "None" ? true : false,
      taskPercentage: props.taskData?.percentage ? parseInt(props.taskData?.percentage) : 0,
      taskStatus: props.taskData?.taskStatus ? props.taskData?.taskStatus : "In Progress",
      taskPriority: props.taskData?.priority ? props.taskData?.priority : "Low",
      reportToDetials: reportToDetial, assigneeDetials: assigneeDetial,
      endDate: end_date, startDate: start, name: props.taskData.summary,
      description: props.taskData?.description, attachmentArray: props.taskData?.attachments,
      startTime: props.taskData?.dtstart ? new Date(props.taskData?.dtstart * 1000).getHours() + ":" +
        (new Date(props.taskData?.dtstart * 1000).getMinutes() < 10 ? '0' : '') +
        new Date(props.taskData?.dtstart * 1000).getMinutes() : "",
      endTime: props.taskData?.dtend ? new Date(props.taskData?.dtend * 1000).getHours() + ":" +
        (new Date(props.taskData?.dtend * 1000).getMinutes() < 10 ? '0' : '') +
        new Date(props.taskData?.dtend * 1000).getMinutes() : "", uid: props.taskData.uid
    });
  }, [props.taskData]);

  const disabledDate = (from: any, current: any, to: any) => {
    let date1 = new Date(from);
    let date2 = new Date(to);
    let ddate = date1.getTime() < date2.getTime() ? (from.getDate() - 1) : (from.getDate());
    return new Date(from.setDate(ddate)) >= current;
  };

  const selectStatus = (val: any) => {
    setcreateTask({ ...createTask, taskStatus: val.key });
    createTask['taskStatus'] = val.key;
    contactService.completedTask(createTask,isContact)
    toastInformation("Success! Task status updated", 'success');
  };

  const selectPriority = (val: any) => {
    setcreateTask({ ...createTask, taskPriority: val.key });
    createTask['taskPriority'] = val.key;
    contactService.completedTask(createTask,isContact)
    toastInformation("Success! Task priority updated", 'success');
  };

  const selectPercentage = (val: any) => {
    setcreateTask({ ...createTask, taskPercentage: val.key });
    createTask['taskPercentage'] = val.key;
    contactService.completedTask(createTask,isContact)
    toastInformation("Success! Task Completed", 'success');
  };

  const editEndDate = () => {
    setEndEdit(!isEndEdit);
  };

  const editStartDate = () => {
    setStartEdit(!isStartEdit);
  };




  const uploadFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      fileUpload(e.target.files[0]);
      e.target.value = "";
    }
  };

  const handleDateChange = (date: any, type: any) => {
    if (type === 'endDate' && date) {
      setcreateTask({ ...createTask, startTimeError: false, endDate: date });
      setEndEdit(false);
    }
    if (type === 'startDate' && date) {
      setcreateTask({ ...createTask, startTimeError: false, startDate: date });
      setStartEdit(false);
    }
  };

  const handleDescription = (e: any) => {
    setcreateTask({ ...createTask, description: e.target.value });
  };

  const deleteTask = () => {
    setdeleteTask(true)
  };
  const TaskDelete = () => {
    contactService.deleteContactTask(taskData);
    setdeleteTask(false)
    if (isContact) {
      props.handleToggle();
    }
    else if (chatWindow.isMySpace) {
      chat_reducer.isWindowSlide && ChatService.rightSideToogle();
    }
    else {
      chatSideWindow(true, "", {});
    }
  }
  const closeDeletModal = () => {
    setdeleteTask(false)
  }

  const fileUpload = (data: any) => {
    let formData = new FormData();
    formData.append("doc", data);
    let token: any = getCookie("ssoToken");
    const url: string = `${config().CHAT_RESTAPI_URL}/upload/files`;
    var authkey = {
      "Content-Type": "application/json",
      Authorization: token
    };
    axios
      .post(url, formData, { headers: authkey })
      .then((response: any) => {
        if (response.data && response.data.statusCode === 200) {
          let tempArray: any = [];
          tempArray = createTask.attachmentArray;
          tempArray.push(response.data.files[0].geturl);
          setcreateTask({
            ...createTask, attachmentArray: tempArray
          });
        }
      });
  };

  const cancelEdit = () => {
    setisAssignee(false);
    setcreateTask({
      ...createTask, rruleValue: "", taskPercentage: 0,
      rruleText: "", recurrence: "", taskPriority: "",
      startDate: new Date(), endDate: new Date(), name: "", description: "", assigneeDetials: [], reportToDetials: []
    });
    if (isContact) {
      props.handleToggle();
    }
    else if (chatWindow.isMySpace) {
      chat_reducer.isWindowSlide && ChatService.rightSideToogle();
    }
    else {
      chatSideWindow(true, "tasklist", {});
    }
  };

  const saveEdit = () => {
    let createTaskData: any = createTask;
    let assigneeArray: any = []; let attendeeArray: any = [];
    selectAssignee?.contactDetail.map((list: any) => (
      assigneeArray.push(list)
    ));
    let reportArray: any = [];
    selectReportTo?.contactDetail.map((list: any) => (
      reportArray.push(list)
    ));
    selectAssignee?.selectedmember.map((list: any) => (
      attendeeArray.push(list.toString())
    ));

    let stTime: any = moment(new Date(createTask.startDate)).format('YYYY/MM/DD');
    let eTime: any = moment(new Date(createTask.endDate)).format('YYYY/MM/DD');
    let dtStart: any = createTask.startTime + ' ' + stTime;
    let dtEnd: any = createTask.endTime + ' ' + eTime;
    createTaskData['reportTo'] = selectReportTo.selectedmember;
    createTaskData['attendee'] = attendeeArray;
    createTaskData['dtstart'] = (new Date(dtStart).getTime() / 1000).toFixed(0);
    createTaskData['dtend'] = (new Date(dtEnd).getTime() / 1000).toFixed(0);
    createTaskData['thread_id'] = props.taskData.threadId;
    createTaskData['replace_id'] = props.taskData.replaceId ? props.taskData.replaceId : props.taskData.msgId;
    createTaskData['uid'] = props.taskData.uid;
    const d = new Date();
    const currentTime = moment().format('HH:mm');
    if (!isAssignee) {
      if (selectAssignee.selectedmember.length < 1) {

        setcreateTask({ ...createTask, assigneeError: true });
      }
      else if (Date.parse(moment(new Date(createTask.startDate)).format('MM/DD/YYYY'))
        === Date.parse(moment(d).format('MM/DD/YYYY')) && (currentTime > createTask.startTime)) {

        setcreateTask({ ...createTask, startTimeError: true });
      } else if (Date.parse(moment(new Date(createTask.startDate)).format('MM/DD/YYYY'))
        > Date.parse(moment(new Date(createTask.endDate)).format('MM/DD/YYYY'))) {

        setcreateTask({ ...createTask, endError: true });
      } else if (Date.parse(moment(new Date(createTask.startDate)).format('MM/DD/YYYY'))
        === Date.parse(moment(new Date(createTask.endDate)).format('MM/DD/YYYY')) &&
        createTask.startTime > createTask.endTime) {

        setcreateTask({ ...createTask, endTimeError: true });
      } else {

        contactService.editContactTask(createTaskData, isContact, props.taskData);
        //saveTask(createTaskData,isContact);
        if (isContact) {
          props.handleToggle();
        }
        else if (chatWindow.isMySpace) {
          chat_reducer.isWindowSlide && ChatService.rightSideToogle();
        }
        else {
          chatSideWindow(true, "tasklist", {});
        }
        setcreateTask({
          ...createTask, attachmentArray: [],
          startDate: new Date(), startTime: "", endDate: new Date(), endTime: "", name: "",
          description: "", assigneeDetials: [], reportToDetials: [],
          assigneeError: false, reportError: false, maxReportError: false, rruleValue: "",
          rruleText: "", recurrence: "", startTimeError: false, isRecur: false, endError: false
        });
      }
    }
    else {

      contactService.editContactTask(createTaskData, isContact, props.taskData);
      if (isContact) {
        props.handleToggle();
      } else {
        chatSideWindow(true, "tasklist", {});
      }
      setcreateTask({
        ...createTask, attachmentArray: [],
        startDate: new Date(), startTime: "", endDate: new Date(), endTime: "", name: "",
        description: "", assigneeDetials: [], reportToDetials: [],
        assigneeError: false, reportError: false, maxReportError: false, rruleValue: "",
        rruleText: "", recurrence: "", startTimeError: false, isRecur: false, endError: false
      });
    }


  };

  const addAssignee = (assigneAdd: any) => {
    setAssigneeAdd(assigneAdd);
  };

  const addReport = () => {
    setReportAdd(!reportAdd);
  };
  const handleCancel = () => {
    setpreviewFile({ ...previewFile, isModalVisible: !previewFile.isModalVisible });
  };
  const handleCancel1 = () => {
    setpreviewVideo({ ...previewVideo, isvideoModal: !previewVideo.isvideoModal });
  }
  const handleCancelimageModal = () => {
    setpreviewImage({ ...previewImage, isImageModal: !previewImage.isImageModal })
  }
  const openvideoPreview = (list: any) => {


    let filename = list.split("/");
    let filenameFinal = filename.splice(-1);
    let filext = filenameFinal
      .toString()
      .split(".")
      .splice(-1);

    setpreviewVideo({ ...previewVideo, isvideoModal: true, filename: filenameFinal, filext: filext, fileToOpen: list });
    window.URL = window.URL || window.webkitURL;
    var video = document.createElement('video');
    video.preload = 'metadata';
    video.onloadedmetadata = function () {
      window.URL.revokeObjectURL(list);
      let dur = duration(video.duration)
      setVideoduration(dur);
    }
    video.src = list;
  }


  const openPreview = (list: any) => {


    let filename = list.split("/");
    let filenameFinal = filename.splice(-1);
    let filext = filenameFinal
      .toString()
      .split(".")
      .splice(-1);
    if (pptFormats.indexOf(filext) > -1 &&
      wordFormats.indexOf(filext) > -1 &&
      excelFormats.indexOf(filext) > -1) {
      setpreviewFile({ ...previewFile, isModalVisible: true, filename: filenameFinal, filext: filext, fileToOpen: list });
    }
    else {
      let file: any = {
        filename: filenameFinal, filext: filext, fileToOpen: list
      }
      downloadAlfilesfromAttach(file)
    }

  }

  const openPreviewImage = (list: any) => {

    let filename = list.split("/");
    let filenameFinal = filename.splice(-1);
    let filext = filenameFinal
      .toString()
      .split(".")
      .splice(-1);

    setpreviewImage({ ...previewImage, isImageModal: true, filename: filenameFinal, filext: filext, fileToOpen: list });
  }
  const BlurAssignee = () => {
    setAssigneeAdd(false);
  };

  const onBlurReport = () => {
    setReportAdd(false);
  };

  const handleCheckRecur = (e: any) => {

    if (!e.target.checked) {
      setcreateTask({ ...createTask, rruleText: "", isRecur: e.target.checked });
    }
    else {
      setcreateTask({ ...createTask, isRecur: e.target.checked });
    }
  };

  const removeAttach = (list: any) => {
    setDeleteModal({ ...deleteModal, isModalVisible: true, file: list });
  };

  const confirmDelete = () => {
    let { file } = deleteModal;
    let tempAttch: any = createTask.attachmentArray;
    const index: any = tempAttch.indexOf(file);
    if (index > -1) {
      tempAttch.splice(index, 1);
    }
    setcreateTask({ ...createTask, attachmentArray: tempAttch });
    setpreviewImage({ ...previewImage, isImageModal: false });
    setpreviewVideo({ ...previewVideo, isvideoModal: false });
    setpreviewFile({ ...previewFile, isModalVisible: false });
    setDeleteModal({ ...deleteModal, isModalVisible: false, file: '' });
  }

  const closeModals = () => {
    setDeleteModal({ ...deleteModal, isModalVisible: false, file: '' });
  }


  const removeReportTo = (e: any, list: any) => {

    const memberListResponse: any = _.filter(selectReportTo?.selectedmember, ((data: any) => {
      return data !== list?.sip_login_id;
    }));

    const reporttoList: any = _.filter(selectReportTo?.contactDetail, ((data: any) => {

      return data?.sip_login_id !== list?.sip_login_id;
    }));

    setSelectReportTo({
      ...selectReportTo, selectedmember: memberListResponse,
      contactDetail: reporttoList
    });
    setcreateTask({ ...createTask, reportError: false, maxReportError: false });

  };


  const removeAssignee = (e: any, list: any) => {

    const memberListResponse: any = _.filter(selectAssignee?.selectedmember, ((data: any) => {
      return data !== list?.sip_login_id;
    }));

    const assigneeList: any = _.filter(selectAssignee?.contactDetail, ((data: any) => {

      return data?.sip_login_id !== list?.sip_login_id;
    }));

    setSelectAssignee({
      ...selectAssignee,
      contactDetail: assigneeList, selectedmember: memberListResponse
    });
    setcreateTask({ ...createTask, assigneeError: false });

  };

  const onChangeSelectMembers = (e: any) => {
    let contact: any =
      e.map((item: string) => {
        return getcontactDetail(item.toString(), selectAssignee.contactList, userdetails);
      });
    setSelectAssignee({
      ...selectAssignee, selectedmember: e,
      searchContactList: selectAssignee.contactList, contactDetail: contact
    });
    setAssigneeAdd(false);
    setcreateTask({ ...createTask, assigneeError: false });
  };

  const onSearchMembers = (value: any) => {
    let response = SearchFilter(selectAssignee.contactList, value.toLowerCase());
    setSelectAssignee({ ...selectAssignee, searchContactList: response });

  };

  const onChangeSelectReprot = (e: any) => {
    let contact: any =
      e.map((item: string) => {
        return getcontactDetail(item.toString(), selectReportTo.contactList, userdetails);
      });
    setSelectReportTo({
      ...selectReportTo, selectedmember: e,
      searchContactList: selectReportTo.contactList, contactDetail: contact
    });
    setReportAdd(false);
    setcreateTask({ ...createTask, reportError: false });
  };

  const onSearchReport = (value: any) => {
    let response = SearchFilter(selectReportTo.contactList, value.toLowerCase());
    setSelectReportTo({ ...selectReportTo, searchContactList: response });

  };

  const setEndTime = (val: any) => {

    setcreateTask({ ...createTask, endTime: val.key, startTimeError: false, endError: false });
  };

  const setStartTime = (val: any) => {

    setcreateTask({ ...createTask, startTime: val.key, startTimeError: false, endError: false });
  };

  const updateState = (data: any) => {
    var someDate = new Date();
    var result = new Date(data.byEnddate);
    if (data.recurrence === "Daily" && data.value_disabled === 2) {
      let datechange = someDate.setDate(someDate.getDate() + data.afteroccur);
      result = new Date(datechange);
    } else if (data.recurrence === "Weekly" && data.value_disabled === 2) {
      let datechange = someDate.setDate(someDate.getDate() + (data.afteroccur * 7));
      result = new Date(datechange);
    } else if (data.recurrence === "Monthly" && data.value_disabled === 2) {
      let datechange = someDate.setDate(someDate.getDate() + (data.afteroccur * 30));
      result = new Date(datechange);
    } else {
      result = new Date(data.byEnddate);
    }
    let taskData: any = createTask;
    taskData['endDate'] = result;

    let endTimeUpdate: any = result.getHours() + ":" + result.getMinutes();
    if (data.recurrence !== "None") {

      let rule = TaskRRuleGeneration(data, taskData);
      setcreateTask({
        ...createTask, endTime: endTimeUpdate, endDate: result, rruleValue: rule.toString(),
        rruleText: rule.toText(), recurrence: data.recurrence
      });
    } else {
      setcreateTask({
        ...createTask, endTime: endTimeUpdate, endDate: result, rruleValue: "",
        rruleText: "", recurrence: data.recurrence
      });
    }
  };

  var len = Math.ceil((selectReportTo?.searchContactList?.length / 8));
  var random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();

  const menu = (
    <Menu className="taskviews" onClick={selectStatus}>
      <Menu.Item key={'In Review'}>{createTask.taskStatus === "In Review" ? <span className="icon_tick"></span> : <span className="icon_tick" style={{ visibility: "hidden" }} ></span>}
        <StatusTag className='statusunderReview' name='In Review' />
      </Menu.Item>
      <Menu.Item key={'On Hold'}>{createTask.taskStatus === "On Hold" ? <span className="icon_tick"></span> : <span className="icon_tick" style={{ visibility: "hidden" }} ></span>}
        <StatusTag className='statusHold' name='On Hold' />
      </Menu.Item>
      <Menu.Item key={'In Progress'}>{createTask.taskStatus === "In Progress" ? <span className="icon_tick"></span> : <span className="icon_tick" style={{ visibility: "hidden" }} ></span>}
        <StatusTag className='statusunderinProgress' name='In Progress' />
      </Menu.Item>
      <Menu.Item key={'Completed'}>{createTask.taskStatus === "Completed" ? <span className="icon_tick"></span> : <span className="icon_tick" style={{ visibility: "hidden" }} ></span>}
        <StatusTag className='statusCompleted' name='Completed' />
      </Menu.Item>
    </Menu>
  );

  const menu1 = (
    <Menu className="taskviews" onClick={selectPriority}>
      <Menu.Item key={'High'}>{createTask.taskPriority === "High" ? <span className="icon_tick"></span> : <span className="icon_tick" style={{ visibility: "hidden" }} ></span>}
        <StatusTag className='statusHigh' name='High' />
      </Menu.Item>
      <Menu.Item key={'Medium'}>{createTask.taskPriority === "Medium" ? <span className="icon_tick"></span> : <span className="icon_tick" style={{ visibility: "hidden" }} ></span>}
        <StatusTag className='statusMedium' name='Medium' />
      </Menu.Item>
      <Menu.Item key={'Low'}>{createTask.taskPriority === "Low" ? <span className="icon_tick"></span> : <span className="icon_tick" style={{ visibility: "hidden" }} ></span>}
        <StatusTag className='statusLow' name='Low' />
      </Menu.Item>
    </Menu>
  );


  const menues = (
    <Menu className="deleteviews" onClick={deleteTask}>
      <Menu.Item>Delete</Menu.Item>
    </Menu>
  );


  const percentage = (
    <Menu className="taskviews" onClick={selectPercentage}>

      <Menu.Item key={10}>10</Menu.Item>
      <Menu.Item key={20}>20</Menu.Item>
      <Menu.Item key={30}>30</Menu.Item>
      <Menu.Item key={40}>40</Menu.Item>
      <Menu.Item key={50}>50</Menu.Item>
      <Menu.Item key={60}>60</Menu.Item>
      <Menu.Item key={70}>70</Menu.Item>
      <Menu.Item key={80}>80</Menu.Item>
      <Menu.Item key={90}>90</Menu.Item>
      <Menu.Item key={100}>100</Menu.Item>

    </Menu>
  );
  let timeDurationList: any = Array.from(Array(24).keys());
  const endTime = (
    <Menu className={`${"scroller"} ${styles.timeSelect} ${"rightbarforactions"}`} onClick={setEndTime}>
      {timeDurationList.map((value: string, index: number) => {
        return (
          <>{index === 0 ?
            <>
              <Menu.Item
                key={`${index}:00`}>{`00:00`}</Menu.Item>
              <Menu.Item
                key={`${index}:30`}>{`00:30`}</Menu.Item>
            </>
            :
            <>
              <Menu.Item
                key={`${value.toString().length === 1 ? '0' + value : value}:00`}>{`${value.toString().length === 1 ? '0' + value : value}:00`}</Menu.Item>
              <Menu.Item key={`${value.toString().length === 1 ? '0' + value : value}:30`}
              >{`${value.toString().length === 1 ? '0' + value : value}:30`}</Menu.Item>

            </>
          }
          </>
        );
      })
      }
    </Menu>
  );

  const startTime = (
    <Menu className={`${"scroller"} ${styles.timeSelect}`} onClick={setStartTime}>
      {timeDurationList.map((value: string, index: number) => {
        return (
          <>{index === 0 ?
            <>
              <Menu.Item
                key={`${index}:00`}>{`00:00`}</Menu.Item>
              <Menu.Item
                key={`${index}:30`}>{`00:30`}</Menu.Item>
            </>
            :
            <>
              <Menu.Item
                key={`${value.toString().length === 1 ? '0' + value : value}:00`}>{`${value.toString().length === 1 ? '0' + value : value}:00`}</Menu.Item>
              <Menu.Item key={`${value.toString().length === 1 ? '0' + value : value}:30`}
              >{`${value.toString().length === 1 ? '0' + value : value}:30`}</Menu.Item>

            </>
          }
          </>
        );
      })
      }
    </Menu>
  );

  return (
    <>
      <div className={`scroller ${styles.maintasks} rightbarforactions`}>
        <div className={styles.toplayers}>
          <ul>
            <Dropdown overlay={menu1} placement="bottomRight" trigger={['click']}>
              <li>
                Priority<StatusTag className={createTask.taskPriority === "High" ? 'statusHigh' :
                  createTask.taskPriority === "Medium"
                    ? 'statusMedium' : 'statusLow'} name={createTask.taskPriority} />
                <span className="icon_down-arrow"></span></li></Dropdown>
            <Dropdown overlay={menu} placement="bottomRight" trigger={['click']}>
              <li>
                Status<StatusTag className={createTask.taskStatus === "In Review" ? 'statusunderReview' :
                  createTask.taskStatus === "On Hold" ? 'statusHold' : createTask.taskStatus === "Completed"
                    ? 'statusCompleted' : 'statusunderinProgress'} name={createTask.taskStatus === "In Review" ? "In Review" : createTask.taskStatus} />
                <span className="icon_down-arrow"></span></li></Dropdown>
            <Dropdown overlay={percentage} placement="bottomRight" trigger={['click']}>
              <li>
                Completion<Progress className="progressGreenbg" percent={createTask.taskPercentage} size="small" />
                <span className="icon_down-arrow"></span></li></Dropdown>
          </ul>
        </div>
        <h2>{taskData.summary}{!isAssignee && <><Dropdown overlay={menues} placement="bottomRight">
          <span className="icon_overflow"></span></Dropdown></>}</h2>
        {isAssignee && <><div className={styles.middlelayers}>
          <div className={styles.lefts}>Assignee</div>
          <div className={styles.rights}>
            {selectAssignee.contactDetail.map((list: any, index: any) =>
            (
              <Fragment key={index}>
                <div className={styles.profiles}>
                  <div className={`${styles.usergroups}`}>
                    <URAvatarGroup className='lefts size22' profileInfo={<>
                      {list?.ImageURL || list?.profile_image_url ?
                        <><img alt="" src={list?.ImageURL ? list?.ImageURL : list?.profile_image_url} className={styles.imgSelected} />
                          <URStatusDot
                            className={userStatusColor(list?.user_status, 'small')} /></> :
                        <span>{list?.caller_id?.charAt(0)}<URStatusDot
                          className={userStatusColor(list?.user_status, 'small')} /></span>
                      }
                    </>} /></div>
                  <div className={styles.names}>{list?.caller_id}</div>
                </div>
              </Fragment>
            )
            )}
          </div>
        </div>
          <div className={styles.middlelayers}>
            <div className={styles.lefts}>Start Date</div>
            <div className={styles.rights}>
              <div className={`${styles.overall} 
              ${moment(new Date(createTask.startDate)).format("DD/MM/YYYY") === moment(new Date()).format("DD/MM/YYYY")
                  ? styles.future : moment(new Date(createTask.startDate)).format("x") < moment(new Date()).format("x")
                    ? styles.past : ""}`} onClick={editEndDate}>
                <img src={taskimg1} alt="" />
                {createTask.startDate ?
                  moment(new Date(createTask.startDate)).format("DD/MM/YYYY") === moment(new Date()).format("DD/MM/YYYY") ? "Today" :
                    moment(new Date(createTask.startDate)).format('DD MMM') :
                  "Start Date"}
              </div>
              <div>

                <div className={`${styles.timing} ${styles.overall}`}><img src={taskimg1} alt="" />
                  {createTask.startTime ? createTask.startTime : "Time"}
                </div>
              </div>
            </div>
          </div>
          <div className={styles.middlelayers}>
            <div className={styles.lefts}>Due Date</div>
            <div className={styles.rights}>
              <div className={`${styles.overall} 
              ${moment(new Date(createTask.endDate)).format("DD/MM/YYYY") === moment(new Date()).format("DD/MM/YYYY")
                  ? styles.future : moment(new Date(createTask.endDate)).format("x") < moment(new Date()).format("x")
                    ? styles.past : ""}`}>
                <img src={taskimg1} alt="" />
                {createTask.endDate ?
                  moment(new Date(createTask.endDate)).format("DD/MM/YYYY") === moment(new Date()).format("DD/MM/YYYY") ? "Today" :
                    moment(new Date(createTask.endDate)).format('DD MMM') :
                  "End Date"}
              </div>
              <div>

                <div className={`${styles.timing} ${styles.overall}`}><img src={taskimg1} alt="" />
                  {createTask.endTime ? createTask.endTime : "Time"}
                </div>
              </div>
            </div>
          </div>
          {createTask.rruleText && <div className={styles.middlelayers}>
            <div className={styles.lefts}>Recurring task</div>
            <div>
              {createTask.rruleText}
            </div>
          </div>}

          <div className={`${styles.fortextarea} ${styles.middlelayers}`}>
            <div className={styles.lefts}>Decription</div>


            <div className={`scroller ${styles.rights}`}>
              <div> {createTask.description}</div>
            </div>
          </div>
          {createTask.reportToDetials && <div className={styles.middlelayers}>
            <div className={styles.lefts}>Report to</div>
            <div className={`${styles.rights} ${styles.overrights}`}>
              {createTask.reportToDetials.map((list: any) =>
              (
                <>
                  <div className={styles.profiles}>
                    <div className={`${styles.usergroups}`}>
                      <URAvatarGroup className='lefts size22' profileInfo={<>
                        {list?.ImageURL || list?.profile_image_url ?
                          <><img alt="" src={list.ImageURL ? list?.ImageURL : list?.profile_image_url} className={styles.imgSelected} />
                            <URStatusDot
                              className={userStatusColor(list?.user_status, 'small')} /></> :
                          <span>{list?.caller_id?.charAt(0)}<URStatusDot
                            className={userStatusColor(list?.user_status, 'small')} /></span>
                        }
                      </>} /></div>
                    <div className={styles.names}>{list?.caller_id}</div>
                  </div>
                </>
              )

              )}


            </div>
          </div>}</>}
        {!isAssignee && <><div className={styles.middlelayers}>
          <div className={styles.lefts}>Assignee</div>
          <div className={`${styles.rights} ${styles.overrights}`}>
            {selectAssignee.contactDetail.map((list: any, index: any) =>
            (
              <div className={styles.profiles} key={index}>
                <div className={`${styles.usergroups}`}>
                  <URAvatarGroup className={`lefts size20 colorBG${random_color[index]}`} profileInfo={<>
                    {list?.ImageURL || list?.profile_image_url ?
                      <><img alt="" src={list.ImageURL ? list?.ImageURL : list?.profile_image_url} className={styles.imgSelected} />
                        <URStatusDot
                          className={userStatusColor(list?.user_status, 'small')} /></> :
                      <span>{list?.caller_id?.charAt(0)}<URStatusDot
                        className={userStatusColor(list?.user_status, 'small')} /></span>
                    }
                  </>} /></div>
                <div className={styles.names}>{list?.caller_id}</div>
                <span className={`icon_close ${styles.closing}`} onClick={(e: any) => removeAssignee(e, list)}></span>
              </div>

            )
            )}
            {createTask.assigneeError && <span className="error">Assignee Required</span>}
            <div className={styles.selectusers}>
              <Tooltip mouseEnterDelay={0.5} placement="left" title="Add Assignee">
                <div className={styles.addmem} onClick={() => addAssignee(!assigneAdd)} >
                  +
                </div>
              </Tooltip>
              {assigneAdd && <div onBlur={BlurAssignee}>

                <div className={styles.insideicon}>
                  <img src={taskimg2} alt="" /><Select
                    mode="multiple"
                    onChange={(e: any) => onChangeSelectMembers(e)}
                    onSearch={onSearchMembers}
                    style={{ width: '100%' }}
                    filterOption={false}
                    showSearch={true}
                    value={selectAssignee.selectedmember}
                    placeholder="Select Assignee"
                    className="newselects taskcreations foreventing">
                    {selectAssignee?.searchContactList?.map((contact: any, index: any) => {
                      let name = contact?.caller_id ? contact?.caller_id : contact?.team_name;
                      return (
                        <option key={index}
                          value={contact.sip_login_id ? contact.sip_login_id : `con${contact.team_id}`}>
                          <div className="dropdowndesign">
                            <div className="usergroupss">
                              <URAvatarGroup className={`lefts size22 colorBG${random_color[index]}`} profileInfo={<>
                                {contact?.ImageURL || contact?.profile_image_url ?
                                  <><img alt="" src={contact?.ImageURL ? contact?.ImageURL : contact?.profile_image_url} className={styles.imgSelected} />
                                    <URStatusDot
                                      className={userStatusColor(contact?.user_status, 'small')} /></> :
                                  <span>{contact?.caller_id?.charAt(0)}<URStatusDot
                                    className={userStatusColor(contact?.user_status, 'small')} /></span>
                                }
                              </>} />
                            </div>
                            <div className="names">{name && name}</div>
                            {!contact.team_id && <div className="ext">{contact?.ext}</div>}
                          </div>
                        </option>
                      );
                    })}
                  </Select></div></div>}
            </div>
          </div>
        </div>
          <div className={styles.middlelayers}>
            <div className={styles.lefts}>Start Date</div>
            <div className={styles.rights}>

              <div className={styles.actionnews}>
                {isStartEdit && <DatePicker className="customDatepicker" format={'DD/MM/YYYY'}
                  disabledDate={(e) => disabledDate(new Date(), e, createTask.startDate)}
                  defaultValue={createTask.startDate ? moment(createTask.startDate) : moment(new Date())}
                  dropdownClassName='datepickerDropdown' placeholder='Start date'
                  onChange={(date: any) => handleDateChange(date, 'startDate')} />}
              </div>
              <div className={`${styles.overall} 
              ${moment(new Date(createTask.startDate)).format("DD/MM/YYYY") === moment(new Date()).format("DD/MM/YYYY")
                  ? styles.future : moment(new Date(createTask.startDate)).format("x") < moment(new Date()).format("x")
                    ? styles.past : ""}`} onClick={editStartDate}>
                <img src={taskimg1} alt="" />
                <Tooltip mouseEnterDelay={0.5} placement="top" title="Start Date">
                  {createTask.startDate ?
                    moment(new Date(createTask.startDate)).format("DD/MM/YYYY") === moment(new Date()).format("DD/MM/YYYY") ? <label>Today</label> :
                      <label> {moment(new Date(createTask.startDate)).format('DD MMM')} </label> :
                    <label>Start Date</label>}
                </Tooltip>
                <span className="icon_close"></span>
              </div>
            </div>
            {createTask.startTimeError ? <span className="error spacingerror">Select valid Time</span> : null}
          </div>

          <div className={styles.middlelayers}>
            <div className={styles.lefts}>Time</div>
            <div className={styles.rights}>
              <div>
                <Dropdown overlay={startTime} className={createTask.startTimeError ? "errorInput" : ''}
                  placement="bottomRight">
                  <div className={`${styles.timing} ${styles.overall}`}><img src={taskimg1} alt="" />
                    <Tooltip mouseEnterDelay={0.5} placement="top" title="Start Time">
                      <label>{createTask.startTime ? createTask.startTime : "Time"} </label></Tooltip>
                    <span className="icon_close"></span>
                  </div></Dropdown>
              </div>
            </div>
            {createTask.startTimeError ? <span className="error spacingerror">Select valid Time</span> : null}
          </div>
          <div className={styles.middlelayers} >
            <div className={styles.lefts}>Due Date</div>
            <div className={styles.rights}>

              <div className={styles.actionnews}>
                {isEndEdit &&
                  <DatePicker className="customDatepicker" format={'DD/MM/YYYY'}
                    disabledDate={(e) => disabledDate(new Date(), e, createTask.endDate)}
                    defaultValue={moment(createTask.endDate)}
                    dropdownClassName='datepickerDropdown'
                    placeholder='EndDate' onChange={(date: any) => handleDateChange(date, 'endDate')} />}
              </div>
              <div className={createTask.endError ? "errorInput" : ''}>
                <div className={`${styles.overall} 
              ${moment(new Date(createTask.endDate)).format("DD/MM/YYYY") === moment(new Date()).format("DD/MM/YYYY")
                    ? styles.future : moment(new Date(createTask.endDate)).format("x") < moment(new Date()).format("x") ? styles.past : ""}`} onClick={editEndDate}>

                  <img src={taskimg1} alt="" />
                  <Tooltip mouseEnterDelay={0.5} placement="top" title="Due Date" >
                    {createTask.endDate ?
                      moment(new Date(createTask.endDate)).format("DD/MM/YYYY") === moment(new Date()).format("DD/MM/YYYY") ? <label>Today</label> :
                        <label>{moment(new Date(createTask.endDate)).format('DD MMM')}</label> :
                      <label>End Date</label>}
                  </Tooltip>
                  <span className="icon_close"></span>
                </div>
              </div>
            </div>
          </div>

          <div className={styles.middlelayers} >
            <div className={styles.lefts}>Time</div>
            <div className={styles.rights}>
               <div>
                <Dropdown overlay={endTime}
                  placement="bottomRight" className={createTask.endTimeError ? "errorInput" : ''}>
                  <div className={`${styles.timing} ${styles.overall}`}><img src={taskimg1} alt="" />
                    <Tooltip mouseEnterDelay={0.5} placement="top" title="Due Time">
                      <label>{createTask.endTime ? <label>{createTask.endTime}</label> : <label>Time</label>} </label></Tooltip>
                    <span className="icon_close"></span>
                  </div></Dropdown>
              </div>
            </div>
          </div>
          <div className={styles.middlelayers}>
            <div className={`${styles.lefts} ${styles.cuslefts}`}>
              <div className={`customchecksize right8 ${styles.bottomFooterSec}`}>
                <Space>
                  <URCheckBoxCall onChange={handleCheckRecur} checked={createTask.isRecur} />
                  <span className={styles.saveTxttop}>Recurring task</span>
                </Space>
              </div>
            </div>
            {createTask.rruleText && <div className={styles.middlelayers}>

              <div className={`${styles.rights} ${styles.cusrights}`}>
                {createTask.rruleText}
              </div>
            </div>}
            <div>
              {createTask.isRecur && <ClickDropdown recur={props.taskData} updateState={updateState}></ClickDropdown>}
            </div>
          </div>
          <div className={`${styles.fortextarea} ${styles.middlelayers}`}>
            <div className={styles.lefts}>Decription</div>

            <div className={styles.rights}>
              <TextArea value={createTask.description} placeholder="Add more details to this task…" onChange={handleDescription}></TextArea>
            </div>
          </div>
          <div className={styles.middlelayers}>
            <div className={styles.lefts}>Report to</div>
            <div className={`${styles.rights} ${styles.overrights}`}>
              {selectReportTo?.contactDetail?.map((list: any, index: any) =>
              (
                <>
                  <div className={styles.profiles}>
                    <div className={`${styles.usergroups}`}>
                      <URAvatarGroup className={`lefts size22 colorBG${random_color[index]}`} profileInfo={<>
                        {list?.ImageURL || list?.profile_image_url ?
                          <><img alt="" src={list.ImageURL ? list?.ImageURL : list?.profile_image_url} className={styles.imgSelected} />
                            <URStatusDot
                              className={userStatusColor(list?.user_status, 'small')} /></> :
                          <span>{list?.caller_id?.charAt(0)}<URStatusDot
                            className={userStatusColor(list?.user_status, 'small')} /></span>
                        }
                      </>} /></div>
                    <div className={styles.names}>{list?.caller_id}</div>
                    <span className="icon_close" onClick={(e: any) => removeReportTo(e, list)}></span>
                  </div>
                </>
              )

              )}

              <div className={styles.selectusers}>
                {selectReportTo?.contactDetail?.length < 2 && <div className={styles.addmem} onClick={addReport} >+</div>}
                {reportAdd && <div onBlur={onBlurReport}>
                  <div className={styles.insideicon}>
                    <img src={taskimg2} alt="" /><Select
                      mode="multiple"
                      onChange={(e: any) => onChangeSelectReprot(e)}
                      onSearch={onSearchReport}
                      style={{ width: '100%' }}
                      filterOption={false}
                      showSearch={true}
                      value={selectReportTo.selectedmember}
                      placeholder="Select Report to"
                      className="newselects taskcreations foreventing"
                      dropdownClassName="newChatSel">
                      {selectReportTo?.searchContactList?.map((contact: any, index: any) => {

                        let name = contact?.caller_id ? contact?.caller_id : contact?.team_name;
                        return (

                          <option key={index}
                            value={contact?.sip_login_id ? contact?.sip_login_id : `con${contact?.team_id}`}>
                            <div className="dropdowndesign">
                              <div className="usergroupss">
                                <URAvatarGroup className={`lefts size22 colorBG${random_color[index]}  ${styles.avatarset}`} profileInfo={<>
                                  {contact?.ImageURL ?
                                    <img src={contact?.ImageURL} alt="" className={styles.imgSelected} /> :
                                    <span>{contact?.caller_id.charAt(0)}</span>}
                                  <URStatusDot
                                    className={userStatusColor(contact?.user_status, 'small')} />
                                </>} />
                              </div>
                              <div className="names">{name && name}</div>
                              {!contact.team_id && <div className="ext">{contact?.ext}</div>}
                            </div>
                          </option>

                        );


                      })}

                    </Select></div></div>}
              </div>

            </div>

          </div>

        </>}
        <div className={styles.middlelayers}>
          <div className={styles.leftsfull}>Attachment</div>
          <div className={styles.rightsfull}>
            {createTask.attachmentArray && createTask.attachmentArray.map((list: any, i: any) => {
              const filename = list.split("/");
              const filenameFinal = filename.splice(-1);
              const filext = filenameFinal
                .toString()
                .split(".")
                .splice(-1);
              return (
                <div className={styles.callsSummaryList} key={i}>
                  <div className={styles.callsSummaryImage}>
                    {imageFormat.indexOf(filext.join()) !== -1 ?
                      <img src={list} alt="" onClick={() => openPreviewImage(list)} /> :
                      excelFormats.indexOf(filext.join()) !== -1 ?
                        <img src={iconxls} alt="" onClick={() => openPreview(list)} /> :
                        pptFormats.indexOf(filext.join()) !== -1 ?
                          <img src={iconppt} alt="" onClick={() => openPreview(list)} /> :
                          wordFormats.indexOf(filext.join()) !== -1 ?
                            <img src={iconword} alt="" onClick={() => openPreview(list)} /> :
                            zipFormats.indexOf(filext.join()) !== -1 ?
                              <img src={iconzip} alt="" onClick={() => openPreview(list)} /> :
                              videoFormat.indexOf(filext.join()) !== -1 ?
                                <video className="videoFluid" onClick={() => openvideoPreview(list)} controls={true} autoPlay={false} preload="metadata">
                                  <source src={list} type="video/mp4" />
                                </video> :
                                <img src={iconpdf} alt="" onClick={() => openPreview(list)} />
                    }</div>
                  <div className={styles.callsSummaryDetails} onClick={() => openPreview(list)}>
                    <span className={styles.callsSummaryName}>{filenameFinal}</span>

                  </div>
                  <Tooltip mouseEnterDelay={0.5} placement="top" title="Remove">
                    <span className={`${styles.closeicon} ${"icon_close"}`}
                      onClick={() => removeAttach(list)}></span></Tooltip>

                </div>

              );
            }
            )}

            <div className={styles.addmem}>
              <input
                id="input"
                type="file"
                onChange={uploadFile}
              /><span className={styles.plusIcon}>+</span></div>
          </div>

        </div>

        {!isAssignee && <div className={styles.bottomlayers}>
          <URButton name="Cancel" onClick={cancelEdit} className="urButton buttonWhite" />
          {memberList.includes(userdetails.sip_login_id) || chatWindow?.chatWindowDetails?.sip_login_id ? <URButton name="Save" onClick={saveEdit} className="urButton buttonBlue marlftmin" /> : null}
        </div>}
      </div>

      <Modal title="Delete this attachment?"
        centered
        visible={deleteModal.isModalVisible}
        onOk={confirmDelete}
        onCancel={closeModals}
        cancelText="Cancel"
        okText="Delete"
        cancelButtonProps={{ className: 'urButton buttonWhite' }}
        okButtonProps={{ className: 'urButton buttonRed' }} className="customPopup">
        Are you sure want to delete the attachment?
      </Modal>

      <Modal title="Delete Task?"
        centered
        visible={deletetask}
        onOk={TaskDelete}
        onCancel={closeDeletModal}
        cancelText="Cancel"
        okText="Delete"
        cancelButtonProps={{ className: 'urButton buttonWhite' }}
        okButtonProps={{ className: 'urButton buttonRed' }} className="customPopup">
        Are you sure you want to permanently delete this task?
      </Modal>

      <Modal
        visible={previewFile.isModalVisible}
        onCancel={handleCancel}
        className="imagepreviewmodal">
        <div className="modalheaders">
          <h2>{previewFile && previewFile?.filename}</h2>
          <ul>
            <li>
              <Tooltip mouseEnterDelay={0.5} placement="top" title={'Delete'}>
                <span className="icon_delete" onClick={() => removeAttach(previewFile.fileToOpen)}></span></Tooltip></li>
            <li><Tooltip mouseEnterDelay={0.5} placement="top" title={'Download'}>
              <span className="icon_Downloadstroke"
                onClick={() => downloadAlfilesfromAttach(previewFile)}></span></Tooltip></li>
            <li>
              <Tooltip mouseEnterDelay={0.5} placement="top" title={'Close'}
              >
                <span className="icon_close" onClick={handleCancel}>
                </span></Tooltip></li>
          </ul>
        </div>
        <div className="chatNoteImgContent">
          <iframe
            src={previewFile.fileToOpen}
            frameBorder="0"
            scrolling="auto"
            height="400"
            width="100%"
            title="#"
          ></iframe>
        </div>

      </Modal>
      <Modal
        centered
        visible={previewVideo.isvideoModal}
        onCancel={handleCancel1} className="imageVideowmodal">
        <div className="modalheaders">
          <h2>{previewVideo.filename}</h2>
          <ul>
            <li>
              <Tooltip mouseEnterDelay={0.5} placement="top" title={'Delete'}>
                <span className="icon_delete" onClick={() => removeAttach(previewVideo.fileToOpen)}></span></Tooltip></li>
            <li><Tooltip mouseEnterDelay={0.5} placement="top" title={'Download'}>
              <span className="icon_Downloadstroke"
                onClick={() => downloadAlfilesfromAttach(previewVideo)}></span></Tooltip></li>
            <li><Tooltip mouseEnterDelay={0.5} placement="top" title={'Close'}>
              <span className="icon_close" onClick={handleCancel1}>
              </span></Tooltip></li>
          </ul>
        </div>
        <div className="chatPlayerAudioConsec">
          <video className="videoFluid" controls preload="metadata" id="videoPlayer" >
            <source src={previewVideo.fileToOpen} type="video/mp4" />
          </video>
        </div>
        <div className={styles.playerContainer}>
          <div className={styles.controlSmall}>
            <Tooltip mouseEnterDelay={0.5} placement="top" title={isPlay ? "Pause" : "Play"}>
              <div className={isPlay ? styles.pauseIcon : styles.playIcon} onClick={handlePausePlay}>
              </div></Tooltip>
          </div>
          <Slider defaultValue={0} value={seektime} tooltipVisible={false} className="videoSliderColor" />
        </div>
        {<div className={styles.duration}>{currentduration} / {videoduration}</div>}
      </Modal>

      <Modal visible={previewImage.isImageModal} className="imagepreviewmodal">
        <div className="modalheaders">
          <h2>{previewImage.filename}</h2>
          <ul>
            <li>
              <Tooltip mouseEnterDelay={0.5} placement="top" title={'Delete'}>
                <span className="icon_delete" onClick={() => removeAttach(previewImage.fileToOpen)}></span></Tooltip></li>
            <li><Tooltip mouseEnterDelay={0.5} placement="top" title={'Download'}>
              <span className="icon_Downloadstroke"
                onClick={() => downloadAlfilesfromAttach(previewImage)}></span></Tooltip></li>
            <li><Tooltip mouseEnterDelay={0.5} placement="top" title={'Close'}
            >
              <span className="icon_close" onClick={handleCancelimageModal}>
              </span></Tooltip></li>
          </ul>
        </div>
        <div className="imagepreview">
          <ImageZoom url={previewImage.fileToOpen} ></ImageZoom>
        </div>
      </Modal>
    </>
  );
};





